var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3987 26.4233C27.9778 26.0374 28.7423 25.9582 29.3938 26.2173C29.6112 26.3038 29.7541 26.5147 29.7542 26.7485V29.1851C29.7541 29.5003 29.4981 29.7561 29.1829 29.7563H10.8167C10.5013 29.7562 10.2454 29.5004 10.2454 29.1851V26.7485C10.2454 26.5146 10.3882 26.3038 10.6057 26.2173C11.2569 25.9582 12.0217 26.0374 12.6008 26.4233C12.9289 26.642 13.3534 26.642 13.6819 26.4233C14.3951 25.948 15.3173 25.9479 16.0305 26.4233C16.1888 26.5287 16.3695 26.5829 16.551 26.5864C17.2346 27.787 18.4934 28.6118 19.9885 28.6118C21.4813 28.6118 22.7864 27.7948 23.4768 26.5854C23.6486 26.5771 23.8189 26.5231 23.969 26.4233C24.6822 25.9478 25.6044 25.9479 26.3176 26.4233C26.6457 26.642 27.0706 26.642 27.3987 26.4233ZM24.2063 10.3804C24.6981 9.97042 25.3928 10.5638 25.0627 11.1138C21.6404 16.8178 22.3261 21.0036 22.6946 23.2524C22.7858 23.809 22.8577 24.2488 22.8577 24.6128C22.8575 26.2124 21.5554 27.469 19.9895 27.4692C18.3382 27.4692 17.1431 26.0638 17.1428 24.4907C17.1428 18.555 19.5073 14.1922 23.928 10.6079C24.0326 10.5231 24.126 10.4473 24.2063 10.3804ZM16.176 21.7544C16.0579 22.6417 15.9993 23.5545 15.9993 24.4897C15.9993 24.7138 16.0161 24.9352 16.05 25.1509C15.1157 24.7802 14.0333 24.8588 13.1409 25.4116C12.2522 24.8621 11.1631 24.7869 10.2454 25.1313V22.3267C10.2454 22.0113 10.5013 21.7545 10.8167 21.7544H16.176ZM29.1829 21.7544C29.4984 21.7544 29.7542 22.0112 29.7542 22.3267V25.1313C28.8363 24.7869 27.7472 24.8621 26.8586 25.4116C25.9591 24.8544 24.8851 24.7862 23.9651 25.144C23.9887 24.9701 24.0012 24.7928 24.0012 24.6128C24.0012 24.1561 23.9223 23.6758 23.8225 23.0679C23.7604 22.6884 23.6883 22.2493 23.6311 21.7544H29.1829Z",
    fill: "url(#paint0_radial_5230_24410)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5848 35.4548) rotate(-90) scale(30.0284 89.6151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK13);
export default __webpack_public_path__ + "static/media/K13.c3351e874e0b3b9692858a650d050d18.svg";
export { ForwardRef as ReactComponent };